<template>
  <div>
    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <span class="m-0 font-weight-bold text-primary">Products List</span>
        <button
          class="pull-right btn btn-primary"
          @click="add_product_model = !add_product_model"
        >
          <i class="fa fa-plus"></i>
        </button>
      </div>
      <b-modal
        v-model="add_product_model"
        title="Add Products"
        hide-footer=""
        size="lg"
      >
        <div v-if="addProductloading">
          <div class="col-md-12 text-center">
            <sweetalert-icon :icon="loadingType" />
          </div>
          <div class="col-md-12 text-center">
            <h3 class="text-center">{{ loadingMessage }}</h3>
          </div>
        </div>
        <b-form v-on:submit.prevent="SaveProducts" v-else>
          <b-row>
            <b-col md="12">
              <b-form-group label="Product Category:">
                <b-form-select
                  v-model="newProducts.productCategory"
                  required
                  class="form-control"
                  :options="categorylist"
                >
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Product Name:">
                <b-form-input
                  id="input-1"
                  v-model="newProducts.name"
                  type="text"
                  required
                  class="form-control"
                  placeholder="Enter Product Name"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Product Name in Hindi:">
                <b-form-input
                  id="input-1"
                  v-model="newProducts.nameHindi"
                  type="text"
                  required
                  class="form-control"
                  placeholder="Enter Product Name in Hindi"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="Product Description:">
                <b-form-textarea
                  v-model="newProducts.description"
                  rows="3"
                  max-rows="6"
                  required
                  class="form-control"
                  placeholder="Enter Description Name"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Product Keyword:">
                <b-form-input
                  id="input-1"
                  v-model="newProducts.keyword"
                  type="text"
                  required
                  class="form-control"
                  placeholder="Enter Keyword (example,example)"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="GST(%)">
                <b-form-select
                  v-model="newProducts.gst"
                  required
                  class="form-control"
                  :options="gstList"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="HSN Code">
                <b-form-input
                  type="number"
                  v-model="newProducts.hsn"
                  required
                  class="form-control"
                  placeholder="HSN Code"
                  maxlength="2"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Includes:">
                <b-form-checkbox v-model="newProducts.veg"
                  >Pure Veg</b-form-checkbox
                >
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Unit Type:">
                <b-form-select
                  v-model="newProducts.unitType"
                  required
                  class="form-control"
                  :options="unitlist"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Select Product Image">
                <input
                  type="file"
                  @change="previewImage"
                  accept="image/*"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col>
              <button type="submit" class="btn btn-success btn-lg form-control">
                Save
              </button>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>
      <div class="card-body">
        <div v-if="loading">
          <sweetalert-icon class="text-center" icon="loading" />
        </div>
        <div class="table-responsive" v-else>
          <table
            class="table table-bordered"
            id="dataTable"
            width="100%"
            cellspacing="0"
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Photo</th>
                <th style="width:25%">Products Name</th>
                <th>GST(%)</th>
                <th>HSN Code</th>
                <th>Pure Veg</th>
                <th>Products Category</th>
                <th>Unit Type</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(product, index) in products" :key="index">
                <td>{{ ++index }}</td>
                <td>
                  <img :src="product.image" height="50px;" weight="50xp;" />
                </td>
                <td>
                  {{ product.name }} <br />
                  <span style="font-size:10px;">
                    {{ product.description }}</span
                  >
                </td>
                <td>
                  {{
                    product.gst === undefined
                      ? "NA"
                      : product.gst === "nill"
                      ? "NILL"
                      : product.gst + "%"
                  }}
                </td>
                <td>
                  {{ product.hsn === undefined ? "NA" : product.hsn }}
                </td>
                <td>
                  <b-badge variant="success" v-if="product.veg == true"
                    ><i class="fa fa-check"> </i
                  ></b-badge>
                  <b-badge variant="danger" v-else
                    ><i class="fa fa-times"></i
                  ></b-badge>
                </td>
                <td>
                  {{ getCategorybyId(product.productCategory) }}
                </td>
                <td>{{ product.unitType }}</td>
                <td>
                  <b-badge variant="success" v-if="product.status == true"
                    >Active</b-badge
                  >
                  <b-badge variant="danger" v-else>Deactivate</b-badge>
                </td>
                <td>
                  <span v-if="product.status == false" class="text-center mr-1">
                    <button
                      class="btn btn-sm btn-success"
                      @click="Approve(product, 'products')"
                      v-b-tooltip.hover
                      title="Approve"
                    >
                      <i class="fa fa-check"></i>
                    </button>
                  </span>
                  <span v-else-if="product.status == true" class="mr-1">
                    <button
                      class="btn btn-sm btn-danger"
                      @click="Disapprove(product, 'products')"
                      v-b-tooltip.hover
                      title="Disapprove"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                  </span>
                  <button
                    class="btn btn-warning btn-sm"
                    @click="editProduct(product)"
                  >
                    <i class="fa fa-pencil"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <b-modal
            v-model="edit_product_model"
            title="Edit Products"
            hide-footer=""
            size="lg"
          >
            <div v-if="addProductloading">
              <div class="col-md-12 text-center">
                <sweetalert-icon :icon="loadingType" />
              </div>
              <div class="col-md-12 text-center">
                <h3 class="text-center">{{ loadingMessage }}</h3>
              </div>
            </div>
            <b-form v-on:submit.prevent="UpdateProducts" v-else>
              <b-row>
                <b-col md="12">
                  <b-form-group label="Product Category:">
                    <b-form-select
                      v-model="editProducts.productCategory"
                      required
                      class="form-control"
                      :options="categorylist"
                    >
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Product Name:">
                    <b-form-input
                      id="input-1"
                      v-model="editProducts.name"
                      type="text"
                      required
                      class="form-control"
                      placeholder="Enter Product Name"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Product Name in Hindi:">
                    <b-form-input
                      id="input-1"
                      v-model="editProducts.nameHindi"
                      type="text"
                      required
                      class="form-control"
                      placeholder="Enter Product Name in Hindi"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="Product Description:">
                    <b-form-textarea
                      v-model="editProducts.description"
                      rows="3"
                      max-rows="6"
                      required
                      class="form-control"
                      placeholder="Enter Description Name"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Product Keyword:">
                    <b-form-input
                      id="input-1"
                      v-model="editProducts.keyword"
                      type="text"
                      required
                      class="form-control"
                      placeholder="Enter Keyword (example,example)"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="GST(%)">
                    <b-form-select
                      v-model="editProducts.gst"
                      required
                      class="form-control"
                      :options="gstList"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="HSN Code">
                    <b-form-input
                      type="number"
                      v-model="editProducts.hsn"
                      required
                      class="form-control"
                      placeholder="HSN Code"
                      maxlength="2"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Includes:">
                    <b-form-checkbox v-model="editProducts.veg"
                      >Pure Veg</b-form-checkbox
                    >
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Unit Type:">
                    <b-form-select
                      v-model="editProducts.unitType"
                      required
                      class="form-control"
                      :options="unitlist"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Select Product Image">
                    <input
                      type="file"
                      @change="previewImage"
                      accept="image/*"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <button
                    type="submit"
                    class="btn btn-success btn-lg form-control"
                  >
                    Save
                  </button>
                </b-col>
              </b-row>
            </b-form>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const $ = window.$;
import { dbFs } from "@/modules/database";
import firebase from "firebase/app";
import "firebase/storage";
export default {
  data() {
    return {
      loading: false,
      dataTable: null,
      addProductloading: false,
      add_product_model: false,
      edit_product_model: false,
      loadingType: "loading",
      loadingMessage: "Uploading",
      products: [],
      category: [],
      categorylist: [],
      unitlist: [
        {
          value: null,
          text: "Select Unit"
        },
        {
          value: "unit",
          text: "Unit"
        }
      ],
      gstList: [
        {
          value: null,
          text: "Select GST"
        },
        {
          value: "nill",
          text: "Nill"
        },
        {
          value: "5",
          text: "5%"
        },
        {
          value: "12",
          text: "12%"
        },
        {
          value: "18",
          text: "18%"
        },
        {
          value: "28",
          text: "28%"
        }
      ],
      imageData: null,
      picture: null,
      uploadValue: 0,
      newProducts: {
        description: "",
        image: null,
        keyword: "",
        keywords: [],
        imageRef: "",
        veg: true,
        hsn: "",
        name: "",
        nameHindi: "",
        productCategory: null,
        status: true,
        unitType: null,
        gst: null
      },
      editProductId: "",
      editProducts: {
        description: "",
        image: null,
        keyword: "",
        keywords: [],
        imageRef: "",
        veg: true,
        hsn: "",
        name: "",
        nameHindi: "",
        productCategory: null,
        unitType: null,
        gst: null
      }
    };
  },
  mounted() {
    this.setupFirebaseReading();
    this.getCategory();
  },
  methods: {
    setupFirebaseReading: function() {
      this.loading = true;
      this.$bind("products", dbFs.collection("products"))
        .then(() => {
          // this.UpdateAllProduct();
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.forDataTable();
        });
    },
    getCategory() {
      // this.loading = true;
      this.$bind("category", dbFs.collection("productCategory"))
        .then(() => {
          this.categorylist.push({
            value: null,
            text: "Select Category"
          });
          for (let index = 0; index < this.category.length; index++) {
            this.categorylist.push({
              value: this.category[index].categoryId,
              text: this.category[index].name
            });
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          // this.loading = false;
        });
    },
    getCategorybyId(id) {
      let CategoryName = "";
      for (let index = 0; index < this.category.length; index++) {
        if (this.category[index].categoryId == id) {
          CategoryName = this.category[index].name;
        }
      }
      return CategoryName;
    },
    previewImage(event) {
      this.uploadValue = 0;
      this.picture = null;
      this.imageData = event.target.files[0];
    },
    SaveProducts() {
      this.addProductloading = true;
      this.loadingMessage = "Image Uploading";
      this.picture = null;
      const storageRef = firebase
        .storage()
        .ref(`products/${this.imageData.name}`)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        snapshot => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        error => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then(url => {
            this.picture = url;
            this.newProducts.image = url;
            this.newProducts.imageRef = `products/${this.imageData.name}`;
            this.splitKeyword("add");
            this.addProduct();
          });
        }
      );
    },
    addProduct() {
      this.addProductloading = true;
      this.loadingMessage = "Adding Products";
      dbFs
        .collection("products")
        .add(this.newProducts)
        .then(doc => {
          this.addProductId(doc.id);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingType = "success";
          this.loadingMessage = "Products Added Successfull";
          this.newProducts = {
            description: "",
            image: null,
            keyword: "",
            keywords: [],
            name: "",
            veg: true,
            hsn: "",
            nameHindi: "",
            productCategory: null,
            status: true,
            unitType: null
          };
          setTimeout(() => {
            this.add_product_model = false;
            this.addProductloading = false;
          }, 3000);
        });
    },
    Approve(data, database) {
      let id = data.id;
      dbFs
        .collection(database)
        .doc(id)
        .update({
          status: true
        })
        .then(() => {
          console.log("Update");
        });
    },
    Disapprove(data, database) {
      let id = data.id;
      dbFs
        .collection(database)
        .doc(id)
        .update({
          status: false
        })
        .then(() => {
          console.log("Update");
        });
    },
    editProduct(product) {
      this.editProducts = product;
      this.editProductId = product.id;
      this.edit_product_model = true;
    },
    UpdateProducts() {
      this.splitKeyword("edit");
      this.addProductloading = true;
      if (this.imageData != null) {
        this.loadingMessage = "Image Uploading";
        this.picture = null;
        const storageRef = firebase
          .storage()
          .ref(`products/${this.imageData.name}`)
          .put(this.imageData);
        storageRef.on(
          `state_changed`,
          snapshot => {
            this.uploadValue =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          },
          error => {
            console.log(error.message);
          },
          () => {
            this.uploadValue = 100;
            storageRef.snapshot.ref.getDownloadURL().then(url => {
              this.picture = url;
              this.editProducts.image = url;
              this.editProducts.imageRef = `products/${this.imageData.name}`;
              this.updateProduct();
            });
          }
        );
      } else {
        this.addProductloading = true;
        this.loadingMessage = "Updating Products";
        this.updateProduct();
      }
    },
    updateProduct() {
      this.addProductloading = true;
      this.loadingMessage = "Updating Products";
      dbFs
        .collection("products")
        .doc(this.editProductId)
        .update(this.editProducts)
        .catch(error => {
          this.loadingType = "error";
          this.loadingMessage = "Products Update UnSuccessfull";
          this.edit_product_model = false;
          this.addProductloading = false;
          console.log(error);
        })
        .finally(() => {
          this.loadingType = "success";
          this.loadingMessage = "Products Update Successfull";
          this.editProductId = "";
          this.editProducts = {
            description: "",
            image: null,
            keyword: "",
            keywords: [],
            veg: true,
            hsn: "",
            name: "",
            productCategory: null,
            status: true,
            unitType: null
          };
          setTimeout(() => {
            (this.add_product_model = false), (this.addProductloading = false);
          }, 3000);
        });
    },
    splitKeyword(type) {
      if (type == "edit") {
        let keyword = this.editProducts.keyword.toLowerCase();
        let newkeyword = keyword.split(/[\s,]+/);
        this.editProducts.keywords = newkeyword;
      } else {
        let keyword = this.newProducts.keyword.toLowerCase();
        let newkeyword = keyword.split(/[\s,]+/);
        this.newProducts.keywords = newkeyword;
      }
    },
    // splitreturn(value) {
    //   let keyword = value.toLowerCase();
    //   let newkeyword = keyword.split(/[\s,]+/);
    //   return newkeyword;
    // },
    // UpdateAllProduct() {
    //   let pp = this.products;
    //   // let keys;
    //   for (const product of pp) {
    //     // let keys = this.splitreturn(product.keyword);
    //     let customer = {
    //       productId: product.id
    //     };
    //     dbFs
    //       .collection("products")
    //       .doc(product.id)
    //       .set(customer, { merge: true })
    //       .then(() => {});
    //   }
    // }
    addProductId(id) {
      console.log(id);
      let customer = {
        productId: id
      };
      dbFs
        .collection("products")
        .doc(id)
        .set(customer, { merge: true })
        .then(() => {});
    },
    forDataTable() {
      this.dataTable = $("#dataTable").DataTable({
        lengthMenu: [10, 20]
      });
    }
  }
};
</script>

<style scoped></style>
